module.exports = __webpack_public_path__ + "static/media/logos_color.47fa14f6.svg";